/* eslint-disable no-console */
import { OFFLINE_DB } from '../constants/indexedDB.constants';
import {
  deleteOfflineDBValueByKey,
  getAllOfflineDBValues,
  setOfflineDBValue,
} from '../utils/indexedDB.offline.utils';

const {
  OBJECT_STORES: { SEARCH_RESULTS },
  KEY_PATHS: { ID },
} = OFFLINE_DB;

export class SearchResultsDBService {
  static async saveSearchResult(searchResult) {
    try {
      return await setOfflineDBValue(SEARCH_RESULTS, searchResult);
    } catch (error) {
      console.log('saveSearchResult(): catch: ', error);
      throw error;
    }
  }

  static async deleteSearchResult(searchResultKey) {
    try {
      return await deleteOfflineDBValueByKey(SEARCH_RESULTS, searchResultKey);
    } catch (error) {
      console.log('saveSearchResult(): catch: ', error);
      throw error;
    }
  }

  static async fetchAllSearchResults() {
    try {
      const results = await getAllOfflineDBValues(SEARCH_RESULTS);
      const userCacheKey = localStorage.getItem('userCacheKey');
      const filteredResults = results.filter((value) => value[ID].split(' + ')[1] === userCacheKey);
      return filteredResults.map((value) => ({ ...value, id: value[ID].split(' + ')[0] }));
    } catch (error) {
      console.log('fetchSavedEntities(): catch: ', error);
      throw error;
    }
  }
}
